module.exports = __webpack_public_path__ + "img/Step1-m.366c866.svg";